// Keep the classic result provenance predicate aligned with Skwach's parser.
const required = ["source", "session_id", "notification_id", "tool_call_id", "observed_tool_name", "server_name", "definition_id", "collection_id"];
const allowed = new Set([...required, "server_label", "evidence_scope"]);
const encoder = new TextEncoder();
const output = /^copilot-vscode-v1:([0-9a-f]{32}):([0-9a-f]{16}):output:([0-9a-f]{16})#result$/;
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function validatedCopilotMcpIdentity(value, origin, callId, name, knownName) {
    if (!value || typeof value !== "object" || Array.isArray(value)
        || !required.every((key) => Object.hasOwn(value, key))
        || Object.keys(value).some((key) => !allowed.has(key))
        || Object.values(value).some((text) => typeof text !== "string" || !text.trim()
            || encoder.encode(text).length > 512 || /[\u0000-\u001f\u007f-\u009f\ud800-\udfff]/u.test(text))
        || Object.hasOwn(value, "evidence_scope") && !["full_session", "recent_updates"].includes(value.evidence_scope)
        || value.source !== "vscode-chat-session-jsonl" || origin?.direction !== "output") return null;
    const id = origin.source_message_id;
    const match = typeof id === "string" && id.length <= 512 && id.endsWith("#result") ? output.exec(id) : null;
    if (!match || match.slice(1).some((part) => /^0+$/.test(part)) || match[2] === match[3]
        || !uuid.test(value.session_id) || /^0+$/.test(value.session_id.replaceAll("-", ""))
        || !uuid.test(value.notification_id) || /^0+$/.test(value.notification_id.replaceAll("-", ""))
        || value.tool_call_id !== callId) return null;
    const server = Array.from(encoder.encode(value.server_name), (byte) =>
        byte >= 65 && byte <= 90 || byte >= 97 && byte <= 122 || byte >= 48 && byte <= 57 || byte === 45
            ? String.fromCharCode(byte) : `%${byte.toString(16).toUpperCase().padStart(2, "0")}`).join("");
    const expected = `mcp__${server}__${value.observed_tool_name}`;
    if (name !== expected || knownName != null && typeof knownName !== "string"
        || knownName && knownName !== expected && knownName !== value.observed_tool_name) return null;
    return { ...value };
}
